import { GradeKey } from '@gyym/sdk'

export { GradeKey } from '@gyym/sdk'

// GradeKeyはサーバサイドで持っている `user_grade_hoge`
// ShortGradeKeyはクライアントサイドで取り回しやすい形にしたもの
export enum ShortGradeKey {
  GREENY = 'greeny',
  BEGINNER = 'beginner',
  LIGHT = 'light',
  STANDARD = 'standard',
  SILVER = 'silver',
  GOLD = 'gold',
  PREMIUM = 'premium',
  VIP = 'vip',
  GYYM_MASTER = 'gyym_master',
}

export const passLabels = {
  [GradeKey.GREENY]: 'GREENY PASS',
  [GradeKey.BEGINNER]: 'BEGINNER PASS',
  [GradeKey.LIGHT]: 'LIGHT PASS',
  [GradeKey.STANDARD]: 'STANDARD PASS',
  [GradeKey.SILVER]: 'SILVER PASS',
  [GradeKey.GOLD]: 'GOLD PASS',
  [GradeKey.PREMIUM]: 'PREMIUM PASS',
  [GradeKey.VIP]: 'VIP PASS',
  [GradeKey.GYYM_MASTER]: 'GYYM MASTER',
}

export const passImages = {
  [GradeKey.GREENY]: '/assets/images/pass/pass_greeny.png',
  [GradeKey.BEGINNER]: '/assets/images/pass/pass_beginner.png',
  [GradeKey.LIGHT]: '/assets/images/pass/pass_light.png',
  [GradeKey.STANDARD]: '/assets/images/pass/pass_standard.png',
  [GradeKey.SILVER]: '/assets/images/pass/pass_silver.png',
  [GradeKey.GOLD]: '/assets/images/pass/pass_gold.png',
  [GradeKey.PREMIUM]: '/assets/images/pass/pass_premium.png',
  [GradeKey.VIP]: '/assets/images/pass/pass_vip.png',
  [GradeKey.GYYM_MASTER]: '/assets/images/pass/pass_gyym_master.png',
}

export const passCircleImages = {
  [GradeKey.GREENY]: '/assets/images/pass/pass_greeny_circle.png',
  [GradeKey.BEGINNER]: '/assets/images/pass/pass_beginner_circle.png',
  [GradeKey.LIGHT]: '/assets/images/pass/pass_light_circle.png',
  [GradeKey.STANDARD]: '/assets/images/pass/pass_standard_circle.png',
  [GradeKey.SILVER]: '/assets/images/pass/pass_silver_circle.png',
  [GradeKey.GOLD]: '/assets/images/pass/pass_gold_circle.png',
  [GradeKey.PREMIUM]: '/assets/images/pass/pass_premium_circle.png',
  [GradeKey.VIP]: '/assets/images/pass/pass_vip_circle.png',
  [GradeKey.GYYM_MASTER]: '/assets/images/pass/pass_gyym_master_circle.png',
}

export const passCircleAltImages = {
  [GradeKey.GREENY]: '/assets/images/pass/pass_greeny_circle_alt.png',
  [GradeKey.BEGINNER]: '/assets/images/pass/pass_beginner_circle_alt.png',
  [GradeKey.LIGHT]: '/assets/images/pass/pass_light_circle_alt.png',
  [GradeKey.STANDARD]: '/assets/images/pass/pass_standard_circle_alt.png',
  [GradeKey.SILVER]: '/assets/images/pass/pass_silver_circle_alt.png',
  [GradeKey.GOLD]: '/assets/images/pass/pass_gold_circle_alt.png',
  [GradeKey.PREMIUM]: '/assets/images/pass/pass_premium_circle_alt.png',
  [GradeKey.VIP]: '/assets/images/pass/pass_vip_circle_alt.png',
  [GradeKey.GYYM_MASTER]: '/assets/images/pass/pass_gyym_master_circle_alt.png',
}
